import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgViewboxDirective } from '@exl-ng/mulo-core';
import {
    ArcviewComponent,
    DictionaryComponent,
    DictionaryItemComponent,
    DictionaryItemContentDirective,
    DictionaryItemLabelDirective,
    LoadingSlateComponent,
    UrlTrustPipe,
    VerticalTabsDirective,
} from '@exl-ng/mulo-common';
import { NavMainLayoutComponent } from '@exl-ng/mulo-views';
import { RouterModule } from '@angular/router';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTabsModule } from '@angular/material/tabs';

import { SharedModule } from '../../shared/shared.module';
import { ArcviewContainerComponent } from './arcview-container/arcview-container.component';

@NgModule({
    imports: [
        CommonModule,
        SvgViewboxDirective,
        ArcviewComponent,
        VerticalTabsDirective,
        UrlTrustPipe,
        NavMainLayoutComponent,
        MatButtonModule,
        MatIconModule,
        MatSidenavModule,
        MatTabsModule,
        SharedModule,
        DictionaryComponent,
        DictionaryItemComponent,
        DictionaryItemLabelDirective,
        DictionaryItemContentDirective,
        RouterModule,
        LoadingSlateComponent,
        ArcviewContainerComponent,
    ],
    exports: [ArcviewContainerComponent],
})
export class ArcviewModule {}
